(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name webAgro1App.controller:WidgetCronogramaCtrl
   * @description
   * # WidgetCronogramaCtrl
   * Controller of the webAgro1App
   */
  angular
    .module('webAgro1App')
    .controller('WidgetCronogramaCtrl', WidgetCronograma);

  WidgetCronograma.$inject = [
    '$rootScope',
    '$scope',
    'LoadingService',
    'Dashboard',
    '$filter',
    'googleChartApiPromise',
    'UsuariosService',
    'AtividadesService',
    '$timeout'
  ];

  // eslint-disable-next-line max-params, max-lines-per-function
  function WidgetCronograma($rootScope, $scope, LoadingService, Dashboard,
    $filter, googleChartApiPromise, UsuariosService, AtividadesService, $timeout) {
    const vm = this;
    const STATUS_ANDAMENTO = 'andamento';
    const STATUS_FINALIZADO = 'finalizado';
    const COLORS = {
      pendente_no_prazo: '#03A9F4',
      realizado_em_atraso: '#FFEB3B',
      realizado_no_prazo: '#4CAF50',
      pendente_em_atraso: '#FF5722'
    };

    //////////////////////////////////////////
    // Controller data
    vm.loading = false;
    vm.empty = false;
    vm.error = false;
    vm.chart = {
      type: 'Timeline',
      data: {
        cols: [],
        rows: []
      },
      options: {
        legend: { position: 'none' },
        width: '100%',
        height: 'auto',
        tooltip: {
          isHtml: true
        },
        focusTarget: 'category',
        hAxis: {
          format: 'dd/MM'
        }
      }
    };

    //////////////////////////////////////////
    // Bindable methods
    vm.validChart = ValidChart;
    vm.calcChartWidth = CalcChartWidth;
    vm.legendColor = LegendColor;

    //////////////////////////////////////////
    // Function declarations

    function ValidChart() {
      return (!!$scope.widget.dataModelOptions.intervalBefore &&
      $scope.widget.dataModelOptions.intervalAfter &&
      !!($scope.widget.dataModelOptions.propriedade || $rootScope.currentPropriedade).id);
    }

    // eslint-disable-next-line complexity, max-lines-per-function
    function ReloadData() {
      if (ValidChart()) {
        vm.loading = true;
        vm.error = false;
        vm.empty = false;
        Dashboard.cronograma({
          propriedade: ($scope.widget.dataModelOptions.propriedade || $rootScope.currentPropriedade || {}).id,
          gleba: ($scope.widget.dataModelOptions.gleba || $rootScope.globalGleba || {}).id,
          data_inicial: moment().subtract($scope.widget.dataModelOptions.intervalBefore, 'days')
            .format('YYYY-MM-DD'),
          data_final: moment().add($scope.widget.dataModelOptions.intervalAfter, 'days')
            .format('YYYY-MM-DD'),
          usuario: ($scope.widget.dataModelOptions.usuario || {}).id,
          cultura: ($scope.widget.dataModelOptions.cultura || {}).id,
          tipos: $scope.widget.dataModelOptions.tipos.map(function(tipo) {
            return tipo.id;
          }).join(',') || null
        // eslint-disable-next-line max-lines-per-function
        }).then(function(response) {
          const data = response.data;
          if (data.length) {
            vm.empty = false;
            const humanize = $filter('humanize');

            const dataGroup = data.reduce(function(group, current) {
              const tipo = humanize(current.tipo);
              if (group[tipo]) {
                group[tipo].push(current);
              } else {
                group[tipo] = [current];
              }
              return group;
            }, {});

            const allData = [
              ['Tipo', 'Ação', { role: 'style' }, { role: 'tooltip', p: { html: true } }, 'Data Inicial', 'Data Final']
            ];
            Object.keys(dataGroup).forEach(function(type) {
              dataGroup[type].forEach(function(group) {
                let acao = group.acao;
                if (!acao) {
                  acao = '';
                }
                const dataInicial = moment(group.data_inicial);
                const dataFinal = moment(group.data_final);
                if (dataFinal.isSame(dataInicial)) {
                  dataFinal.endOf('day');
                }
                allData.push([
                  type, acao, COLORS[group.situacao], Tooltip(group), dataInicial.toDate(), dataFinal.toDate()
                ]);
              });
            });

            const dataTable = google.visualization.arrayToDataTable(allData);

            vm.chart.options.height = allData.length * 26;
            if (vm.chart.options.height < 280) {
              vm.chart.options.height = 280;
            }

            vm.chart.data = dataTable;
          } else {
            vm.empty = true;
          }
        })
          .catch(function(error) {
            console.error(error);
            vm.error = true;
          })
          .finally(function() {
            vm.loading = false;
          });
      }
    }

    function CalcChartWidth() {
      //  Calculation explained @controllers/widgetestacaometeorologica.js
      const parentWidth = (((Number($scope.widget.size.width.slice(0, -1)) / 100)) * window.innerWidth) - 100;
      return parentWidth;
    }

    // eslint-disable-next-line max-lines-per-function, complexity
    function Tooltip(data) {
      const humanize = $filter('humanize');
      const capitalize = $filter('capitalize');
      let output = '<div class="schedule-tooltip">';
      let action = data.acao || '';
      if (!action) {
        action = humanize(data.tipo);
      }
      output += `<p><strong>${ action }</strong></p>`;
      if (data.produtos && !!data.produtos.length) {
        output += '<p><strong>Produtos:</strong> ';
        output += data.produtos.reduce(function(produtos, current) {
          produtos.push(current.descricao);
          return produtos;
        }, []).join(', ');
        output += '</p>';
      }
      if (data.glebas && !!data.glebas.length) {
        output += '<p><strong>Talhões:</strong> ';
        output += data.glebas.reduce(function(glebas, current) {
          glebas.push(humanize((current.gleba || current).descricao));
          return glebas;
        }, []).join(', ');
        output += '</p>';
      }
      if (data.responsavel && data.responsavel.nome_completo) {
        output += `<p><strong>Responsável:</strong> ${ capitalize(data.responsavel.nome_completo) }</p>`;
      }
      output += '<hr>';
      output += `<p><strong>Data inicial:</strong> ${ moment(data.data_inicial).format('DD/MM/YYYY') }</p>`;
      output += `<p><strong>Data final:</strong> ${ moment(data.data_final).format('DD/MM/YYYY') }</p>`;

      if (data.situacao === 'pendente_em_atraso') {
        output += '<p class="text-danger"><strong>TAREFA ATRASADA</strong></p>';
      }

      if (data.status === STATUS_ANDAMENTO && data.percentual_concluido !== null) {
        const percent = data.percentual_concluido * 100;
        output += `
          <div class="progress">
            <div class="progress-bar progress-bar-success" style="width: ${ percent }%;">
              <span>${ $filter('number')(percent, 0) }%</span>
            </div>
          </div>`;
      }
      if (data.status === STATUS_FINALIZADO) {
        output += '<p class="text-success">TAREFA CONCLUÍDA</p>';
        if (data.iniciado_em && data.finalizado_em) {
          output += `<p><strong>Início:</strong> ${ moment(data.iniciado_em).format('DD/MM/YYYY')}`;
          output += `<p><strong>Fim:</strong> ${ moment(data.finalizado_em).format('DD/MM/YYYY')}`;
        }
      }

      output += '</div>';

      return output;
    }

    function LegendColor(name) {
      return {
        backgroundColor: COLORS[name]
      };
    }

    //////////////////////////////////////////
    // Controller logic
    // eslint-disable-next-line max-lines-per-function
    $rootScope.initialize.then(function() {
      $scope.widget.data = {};
      vm.loading = true;

      // Os obj que tem gleba são montados aqui
      $scope.widget.data.propriedades = $rootScope.propriedades.map(function(propriedade) {
        return {
          id: propriedade.id,
          descricao: propriedade.descricao,
          glebas: propriedade.glebas.map(function(gleba) {
            return {
              id: gleba.id,
              descricao: gleba.descricao
            };
          })
        };
      });

      $scope.widget.data.tipos = [
        {
          descricao: 'Recomendação',
          id: 'recomendacao'
        },
        {
          descricao: 'Tarefa',
          id: 'tarefa'
        }
      ];

      UsuariosService.list().then(function(response) {
        $scope.widget.data.usuarios = response.data.map(function(usuario) {
          return {
            id: usuario.id,
            descricao: usuario.nome_completo
          };
        });
      });

      AtividadesService.list().then(function(response) {
        $scope.widget.data.culturas = response.data.map(function(cultura) {
          return {
            id: cultura.id,
            descricao: cultura.descricao
          };
        });
      });

      $scope.$watch('widget.size.width', function() {
        vm.chart.options.width = vm.calcChartWidth();
      });

      googleChartApiPromise.then(function() {
        let timer;
        $scope.$watch('widget.dataModelOptions', _refresh, true);
        $scope.$watch('$root.globalGleba.id', _refresh);

        _refresh();

        function _refresh() {
          if (timer) {
            $timeout.cancel(timer);
            timer = null;
          }
          timer = $timeout(ReloadData, 200);
        }
      });
    });
  }
}());
